{
  "#PRODUCT_SCAN": {
    "APP": "Artikelinfo",
    "TITLE": "Artikelinformationen",
    "FIND": {
      "TITLE": "Artikelinformationen finden",
      "GUIDE_TITLE": "Anleitung",
      "GUIDE": " Um Details zu einem Artikel abzufragen können Sie die Artikel- oder Identnummer manuell eingeben oder den integrierten Scanner des Geräts benutzen.",
      "MANUAL_INPUT": "Manuelle Eingabe",
      "MANUAL_PLACEHOLDER": "Artikel- oder Identnummer",
      "BUTTON": "Artikel suchen",
      "OR": "oder",
      "SCAN_HEADER": "Artikel Scannen",
      "SCAN_DESCRIPTION": "Informationen mithilfe des integrierten Scanners suchen"
    },
    "DETAIL": {
      "TITLE": "Artikelinformationen",
      "ID": "Identnummer",
      "VKP": "VKP",
      "BCP": "BCP",
      "NUMBER": "Artikelnummer",
      "NO_IMAGE": "Es wurde kein Artikelbild gefunden"
    },
    "MESSAGES": {
      "ERROR": {
        "TITLE": "Fehler",
        "SCAN": "Beim Scannen hat etwas nicht geklappt",
        "LOAD": "Der Artikel konnte nicht gefunden werden"
      }
    }
  }
}
